




















































































































































































































































































import { Component, Prop, Emit, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { IButtonToggleItem } from '@/components/molecules/ButtonToggle/ButtonToggle.type'
import { ButtonToggle } from '@/components/molecules/ButtonToggle'
import { InputCode } from '@/components/molecules/InputCode'
import { AtomTextField } from '@/components/atoms'
import {
  AloneSearchType,
  BibliographyClass,
  MaskPattern,
  OrderIdMaxDigits
} from '@/types'
import { systemParameterStore } from '@/utils/store-accessor'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'

export interface InputAloneSearchItem {
  searchType: AloneSearchType
  newPublicationInformationDate: {
    input: string
    errorMessage: string
  }
  newPublicationInformationVolume: {
    input: string
    errorMessage: string
  }
  collectionNo: {
    input: string
    exceptCheckDigit: boolean
    errorMessage: string
  }
  orderId: {
    input: string
    errorMessage: string
  }
  bibliographyId: {
    bibliographyClass: BibliographyClass
    input: string
    errorMessage: string
  }
  isbn: {
    input: string
    errorMessage: string
  }
  productNumber: {
    input: string
    errorMessage: string
  }
  magazineCode: {
    input: string
    errorMessage: string
  }
  marcType: {
    input: string
    errorMessage: string
  }
  marcNo: {
    input: string
    errorMessage: string
  }
}

export const defaultInputAloneSearchItem = (): InputAloneSearchItem => ({
  searchType: 'newPublicationInformationDate',
  newPublicationInformationDate: {
    input: '',
    errorMessage: ''
  },
  newPublicationInformationVolume: {
    input: '',
    errorMessage: ''
  },
  collectionNo: {
    input: '',
    exceptCheckDigit: false,
    errorMessage: ''
  },
  orderId: {
    input: '',
    errorMessage: ''
  },
  bibliographyId: {
    bibliographyClass: BibliographyClass.Real,
    input: '',
    errorMessage: ''
  },
  isbn: {
    input: '',
    errorMessage: ''
  },
  productNumber: {
    input: '',
    errorMessage: ''
  },
  magazineCode: {
    input: '',
    errorMessage: ''
  },
  marcType: {
    input: systemParameterStore?.presetValueSettingOnSearch1?.option5 ?? '',
    errorMessage: ''
  },
  marcNo: {
    input: '',
    errorMessage: ''
  }
})

const TOGGLE_ITEMS_OF_BIBLIOGRAPHY_CLASS: IButtonToggleItem[] = [
  { value: BibliographyClass.Real, text: 'R 物理' },
  { value: BibliographyClass.Set, text: 'S 集合' },
  { value: BibliographyClass.Content, text: 'C 内容' }
]

@Component({
  components: {
    InputCollectionNo,
    InputCode,
    ButtonToggle,
    InputDatePicker
  }
})
export default class BibliographyAloneSearch extends ComponentVue {
  @Ref()
  newPublicationInformationDate!: InputDatePicker

  @Ref()
  newPublicationInformationVolume!: AtomTextField

  @Ref()
  collectionNo!: InputCollectionNo

  @Ref()
  orderId!: AtomTextField

  @Ref()
  bibliographyId!: AtomTextField

  @Ref()
  isbn!: AtomTextField

  @Ref()
  productNumber!: AtomTextField

  @Ref()
  magazineCode!: AtomTextField

  @Ref()
  marcNo!: AtomTextField

  @Prop({ type: Boolean, default: false })
  tooliOnly!: boolean

  @PropSync('input', {
    type: Object
  })
  inputItem!: InputAloneSearchItem

  get alphaMarkNumberOnlyMask(): string {
    return MaskPattern.AlphaMarkNumberOnly
  }

  get newPublicationInformationVolumeMask(): string {
    return 'X'.repeat(10)
  }

  get orderIdMask(): string {
    return '#'.repeat(OrderIdMaxDigits)
  }

  get bibliographyIdMask(): string {
    return '#'.repeat(10)
  }

  get isbnMask(): string {
    return 'X'.repeat(100)
  }

  get productNumberMask(): string {
    return 'X'.repeat(20)
  }

  get magazineCodeMaxlength(): string {
    return '20'
  }

  get marcNoMask(): string {
    return 'X'.repeat(36)
  }

  get toggleItemsOfBibliographyClass(): IButtonToggleItem[] {
    return TOGGLE_ITEMS_OF_BIBLIOGRAPHY_CLASS
  }

  get aloneSearchType(): any {
    return AloneSearchType
  }

  get collectionNoToggleItems(): IButtonToggleItem[] {
    return [
      {
        value: true,
        text: 'CD除く'
      }
    ]
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  focusIsbn(): void {
    this.isbn.atomTextField.focus()
  }

  focusMarcNo(): void {
    this.marcNo.atomTextField.focus()
  }

  focus(): void {
    this.$nextTick(() => {
      switch (this.inputItem.searchType) {
        case AloneSearchType.NewPublicationInformationDate:
          this.newPublicationInformationDate.textField.atomTextField.focus()
          break
        case AloneSearchType.NewPublicationInformationVolume:
          this.newPublicationInformationVolume.atomTextField.focus()
          break
        case AloneSearchType.CollectionNo:
          this.collectionNo.focus()
          break
        case AloneSearchType.OrderId:
          this.orderId.atomTextField.focus()
          break
        case AloneSearchType.Bibliography:
          this.bibliographyId.atomTextField.focus()
          break
        case AloneSearchType.Isbn:
          this.isbn.atomTextField.focus()
          break
        case AloneSearchType.ProductNumber:
          this.productNumber.atomTextField.focus()
          break
        case AloneSearchType.MagazineCode:
          this.magazineCode.atomTextField.focus()
          break
        case AloneSearchType.Marc:
          this.marcNo.atomTextField.focus()
      }
    })
  }

  isDisabled(value: string): boolean {
    return value !== this.inputItem.searchType
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('click:search')
  onSearchClick() {}

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
